import { create } from 'zustand';
import { CatalogOverviewDto } from '../service/interface';
import { SubscriptPlanItem } from '../service/type/subscription';
interface PermissionLevel {
  name: string;
  concurrentGenerations: number | null;
  extendTracks: number | null;
  trimTracks: number | null;
  refill: number | null;
  reimagine: number | null;
  downloadStems: number | null;
  folders: number | null;
  bulkDownloads: number | null;
  wavFiles: number | null;
}
interface StoreState {
  subscriptionStore: Partial<SubscriptPlanItem>;
  setSubscriptionStore: (subscriptionStore: Partial<SubscriptPlanItem>) => void;
  permission: Partial<PermissionLevel>;
  setPermission: (permission: Partial<PermissionLevel>) => void;

}

export const useSubscriptionStore = create<StoreState>((set, get) => {
  return {
    subscriptionStore: {},
    setSubscriptionStore: (subscriptionStore: Partial<SubscriptPlanItem>) => {
      set({ subscriptionStore });
    },
    permission: {},
    setPermission: (permission: Partial<PermissionLevel>) => {
      set({ permission });
    },
  };
});
